/**
 * Returns timestamp (without milliseconds)
 */
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getTimestamp(dateString: string = null) {
  let date;
  if (dateString) {
    date = new Date(dateString);
  } else {
    date = new Date();
  }

  return Math.floor(date.getTime() / 1000);
}

/**
 * Replaces (float) hours number with "X h Y min" format
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function parseFloatHours(hoursFloat: any) {
  if (hoursFloat) {
    const hours = Math.floor(hoursFloat);
    const days = Math.floor(hours / 24);
    const mins = Math.round(60 * (hoursFloat % 1));

    return {
      days,
      hours,
      mins,
    };
  }
  return undefined;
}

/**
 * Return formatted date: YYYY-MM-DD
 */
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(2322): Type 'null' is not assignable to type 'Date'.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function getBaseDate(d: Date = null, opts: any = {}) {
  // eslint-disable-next-line no-param-reassign
  opts = { omitDays: false, ...opts };

  if (!d) {
    // eslint-disable-next-line no-param-reassign
    d = new Date();
  }

  const day = addLeadingZero(d.getDate());
  const month = addLeadingZero(d.getMonth() + 1);
  const year = d.getFullYear();

  if (opts.omitDays) return `${year}-${month}`;
  return `${year}-${month}-${day}`;
}

/**
 * 0 -> 00, 5 -> 05, 10 -> 10, ...
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addLeadingZero(x: any): string {
  const num = parseInt(x, 10);

  if (num >= 0 && num < 10) {
    return `0${num}`;
  }

  return x.toString();
}

/**
 * Returns date object for today+n days, 23:59:59
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function dateInNDays(n: any = 0) {
  const dt = new Date();
  const nd = new Date();

  dt.setHours(0, 0, 0);

  nd.setTime(dt.getTime() + 1000 * 3600 * 24 * parseInt(n, 10));
  nd.setHours(23, 59, 59);

  return nd;
}

/**
 * Returns transform time string like 13:00 to 1:00 am
 *
 * @source models/reports/reports.coffee
 */
export function formatTimeFromHours(rawHours: string): string {
  const hours = parseInt(rawHours, 10) || 24;

  return `${hours > 12 ? hours - 12 : hours}:00 ${hours >= 12 && hours < 24 ? "PM" : "AM"}`;
}
